import React from 'react';
import { array, bool, func } from 'prop-types';

import { SvgIcon } from '../../../svg-icon';
import { UploadAttachmentButton, UploadText } from './styled-components';

import { FILE_MAX_SIZE, FILE_MIME_EXTS } from '../../../../utils';


const UploadAttachments = ({
  openFilePicker, onAttachmentsAdd, isLoading, minView, attachments,
}) => (
  <div>
    <UploadAttachmentButton type="button" disabled={isLoading} onClick={openFilePicker}>
      {minView ?
        (<UploadText>
          {attachments.length ? <React.Fragment><SvgIcon type="plus" style={{ pointerEvents: 'none' }} /> </React.Fragment>
            :
            null}
            Upload {!attachments.length && 'Files'}
        </UploadText>)
        : (<React.Fragment><SvgIcon type="plus" style={{ pointerEvents: 'none' }} /> Upload</React.Fragment>) }
    </UploadAttachmentButton>

    <input
      multiple
      type="file"
      name="files"
      accept={FILE_MIME_EXTS}
      maxLength={FILE_MAX_SIZE}
      style={{ display: 'none' }}
      onChange={onAttachmentsAdd}
    />
  </div>
);

UploadAttachments.propTypes = {
  isLoading: bool,
  openFilePicker: func.isRequired,
  onAttachmentsAdd: func.isRequired,
  minView: bool,
  attachments: array,
};

UploadAttachments.defaultProps = {
  minView: false,
  attachments: [],
  isLoading: false,
};

export default UploadAttachments;



// WEBPACK FOOTER //
// ./src/components/attachments/header/upload-attachments/index.js